module.exports = __webpack_public_path__ + "img/footer-tieba.cbfbb2da.png";